import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { TrendingUp } from 'lucide-react';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip as RechartsTooltip, CartesianGrid, Legend } from 'recharts';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { type IFRiskSnapshot } from '../types/financiamento.types';

interface IFRiskTrendChartProps {
  data: IFRiskSnapshot[];
  isLoading: boolean;
}

export const IFRiskTrendChart: React.FC<IFRiskTrendChartProps> = ({ data, isLoading }) => {
  if (isLoading || data.length < 2) return null;

  const chartData = data.map(d => {
    const dt = new Date(d.data_referencia + 'T12:00:00');
    return {
      periodo: !isNaN(dt.getTime()) ? format(dt, 'dd/MM', { locale: ptBR }) : d.data_referencia,
      score: Number(d.score_composto) || 0,
      progresso: Number(d.progresso_fisico_pct) || 0,
      prob_atraso: Number(d.prob_atraso) || 0,
    };
  });

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <TrendingUp className="h-4 w-4" />
          Tendência de Risco — últimos {data.length} dias
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={240}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
            <XAxis dataKey="periodo" tick={{ fontSize: 11 }} stroke="hsl(var(--muted-foreground))" />
            <YAxis tick={{ fontSize: 11 }} stroke="hsl(var(--muted-foreground))" domain={[0, 100]} />
            <RechartsTooltip
              contentStyle={{
                fontSize: 12,
                background: 'hsl(var(--card))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '6px',
              }}
            />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <Line type="monotone" dataKey="score" name="Score Risco" stroke="hsl(var(--destructive))" strokeWidth={2} dot={false} />
            <Line type="monotone" dataKey="progresso" name="Progresso %" stroke="hsl(var(--primary))" strokeWidth={2} dot={false} />
            <Line type="monotone" dataKey="prob_atraso" name="Prob. Atraso %" stroke="hsl(var(--muted-foreground))" strokeWidth={1} strokeDasharray="5 5" dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
